import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Box } from '@bonanza-social/moonlight';
import { selectPrizeWallQuickRules } from '../../../state/prizeWall/prizeWall.slice';
import { PrizeWallInfoQuickRulesProps } from './PrizeWallInfoQuickRules.types';
import PrizeWallInfoQuickRulesSkeleton from './PrizeWallInfoQuickRulesSkeleton/PrizeWallInfoQuickRulesSkeleton';
import PrizeWallInfoQuickRule from './PrizeWallInfoQuickRule/PrizeWallInfoQuickRule';

function PrizeWallInfoQuickRules(props: PrizeWallInfoQuickRulesProps) {
  const rules = useSelector(selectPrizeWallQuickRules);

  return (
    <Box gap="space-300" {...props}>
      {rules?.length ? (
        rules.map((rule, index) => (
          <PrizeWallInfoQuickRule key={index} {...rule} />
        ))
      ) : (
        <PrizeWallInfoQuickRulesSkeleton />
      )}
    </Box>
  );
}

export default memo(PrizeWallInfoQuickRules);
